import { Spinner } from "phosphor-react"
import { useCallback, useRef } from "react"
import { EVENT_IDS, EVENTS } from "~/common/analytics"
import { trackEvent } from "~/common/analytics"
import { downloadPath } from "~/common/paths"
import { PhoneNumberValue } from "~/common/phone-number"

import { Link } from "~/ui/link"
import { PhoneNumberInput } from "~/ui/phone-number/phone-number-input"
import { useDownloadAppPhoneSubmission } from "~/hooks/use-phone-submission"

const TRACKING_DATA = {
  unique_id: EVENT_IDS.GET_APP_CLICKED,
}

export function GetTheAppDesktop() {
  const phoneInputRef = useRef<HTMLInputElement>(null)

  const { phoneValue, setPhoneValue, submitPhoneNumber, mutationPending } =
    useDownloadAppPhoneSubmission()

  const phoneInputEnabled = () => {
    if (!phoneInputRef.current) return false
    return true
  }

  const handlePhoneChange = useCallback(
    (value: PhoneNumberValue) => {
      setPhoneValue(value)
      if (value.number.replace(/\D/g, "").length >= 10) {
        trackEvent(EVENTS.PHONE_NUMBER_ENTERED, {
          phone_number_last_4: value.number.replace(/\D/g, "").slice(-4),
        })
      }
    },
    [setPhoneValue]
  )

  const handleGetAppClick = async () => {
    await submitPhoneNumber({
      successMessage: "Texting you a link to download the app.",
      trackingData: TRACKING_DATA,
    })

    if (!phoneInputEnabled()) {
      trackEvent(EVENTS.ITEM_PRESSED, {
        ...TRACKING_DATA,
        success: true,
      })
      window.location.href = downloadPath({})
      return
    }
  }

  return (
    <div className="hidden h-20 w-full flex-row pt-8 md:flex">
      <div className="flex flex-row">
        <PhoneNumberInput
          ref={phoneInputRef}
          value={phoneValue}
          onChange={handlePhoneChange}
          onSubmit={handleGetAppClick}
          className="pr-4"
          inputClassName="rounded-xs min-w-60"
        />
        <Link
          // TODO: Find a better way to refactor below code to avoid disabling eslint rule
          // eslint-disable-next-line react-hooks/refs
          to={phoneInputEnabled() ? "#" : downloadPath({})}
          onClick={(e) => {
            e.preventDefault()
            handleGetAppClick()
          }}
        >
          <button className="flex h-12 w-full min-w-[180px] items-center justify-center rounded-full border border-base-black bg-support-yellow py-3">
            <div className="font-md-nichrome text-18 font-medium leading-8 text-base-black">
              {mutationPending ? <Spinner className="animate-spin" /> : "GET THE APP"}
            </div>
          </button>
        </Link>
      </div>
    </div>
  )
}
